import apiApp from "./index";
const token = localStorage.getItem("UserjwtToken");
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const switched = localStorage.getItem("switched");
const switchedSubtenant = JSON.parse(localStorage.getItem("switchedSubtenant"));
// helper: return query param if subTenantId exists
const getSubTenantIdParam = () => {
    if (decodedToken?.isMultitenancy && decodedToken?.subTenantId !== undefined) {
        const subTenantId = decodedToken?.subTenantId;
        return subTenantId ? `&subTenantId=${subTenantId}` : "";
    } else if (switched && switchedSubtenant) {
        return `&subTenantId=${switchedSubtenant?.id}`;
    }
    return "";
};

// Helper: subTenantDTO for request body
const getSubTenantDTO = () => {
  return decodedToken?.isMultitenancy && decodedToken?.subTenantId
    ? { id: decodedToken.subTenantId }
    : null;
};

// Common headers
const getHeaders = () => {
  const headers = {
    Authorization: `Bearer ${token}`,
    "x-Authorization": `${decodedToken?.tenantApiKey}`,
  };

  if (decodedToken?.roles?.includes("TENANT_ADMIN") && decodedToken?.subTenantId === undefined) {
    headers["tenant-login"] = true;
  }

  return headers;
};

const StockApi = {
  // Create Stock Api
  CreateStock: (data) => {
    const jsonData = typeof data === "string" ? JSON.parse(data) : data;
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    data = JSON.stringify(jsonData);

    return apiApp
      .post(`/stock`, jsonData, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List Stock Api
  ListStock: (page, size) => {
    return apiApp
      .get(
        `/stock?page=${page}&size=${size}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  ListStockByStorage: (storageId, page, size) => {
    return apiApp
      .get(
        `/storages/${storageId}/stock-summary?page=${page}&size=${size}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List Stock Level Api
  ListStockLevel: () => {
    return apiApp
      .get(
        `/stockLevel?size=100&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Update Stock Api
  UpdateStock: (StockID, data) => {
    const jsonData = typeof data === "string" ? JSON.parse(data) : data;
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    data = JSON.stringify(jsonData);

    return apiApp
      .put(`/stock/${StockID}`, jsonData, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single Stock Api - Product
  ListStockProduct: (ProductID) => {
    return apiApp
      .get(`/stock/product/${ProductID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`, {
        headers: getHeaders(),
      })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single Stock Api - Invoice Cost
  ListStockInvoiceCost: (InvoiceID,page,size) => {
    return apiApp
      .get(`/stock/invoice/${InvoiceID}?page=${page}&size=${size}&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`, {
        headers: getHeaders(),
      })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single Stock Api - Invoice
  ListStockInvoice: (InvoiceID, page, limit) => {
    return apiApp
      .get(
        `/stock/invoice/${InvoiceID}?page=${page}&size=${limit}&sort=desc&tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Single Stock Api
  SingleStock: (StockID) => {
    return apiApp
      .get(`/stock/${StockID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`, {
        headers: getHeaders(),
      })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // Delete Stock Api
  DeleteStock: (StockID) => {
    return apiApp
      .delete(`/stock/${StockID}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`, {
        headers: getHeaders(),
      })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

ListBatchCode: (param) => {
  return apiApp
    .get(
      `/stock/batch-code/${encodeURIComponent(param)}?tenantId=${decodedToken?.tenantId}${getSubTenantIdParam()}`,
      {
        headers: getHeaders(),
      }
    )
    .then((res) => res.data)
    .catch((err) => Promise.reject(err?.response?.data));
},

  // Waste Stock Api
  WasteStock: (data) => {
    const jsonData = typeof data === "string" ? JSON.parse(data) : data;
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    data = JSON.stringify(jsonData);

    return apiApp
      .post(`/productWaste`, data, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // List product Inventory Report Api
  ListproductInventryReport: (StDate, EDate) => {
    return apiApp
      .get(
        `goodsInward/inventory-report?tenantId=${decodedToken?.tenantId}&startDate=${StDate}&endDate=${EDate}${getSubTenantIdParam()}`,
        { headers: getHeaders() }
      )
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },

  // adjust stock Api
  AdjustStock: (StockID, data) => {
    const jsonData = typeof data === "string" ? JSON.parse(data) : data;
    const subTenantDTO = getSubTenantDTO();
    if (subTenantDTO) jsonData.subTenantDTO = subTenantDTO;
    data = JSON.stringify(jsonData);

    return apiApp
      .put(`/adjust/stock/${StockID}`, jsonData, { headers: getHeaders() })
      .then((res) => res.data)
      .catch((err) => Promise.reject(err?.response?.data));
  },
};

export default StockApi;
